import React from 'react';
import { Col, Nav, NavItem, Row, Button } from 'react-bootstrap';
import { connect, } from 'react-redux';
import { reduxForm, getFormValues } from "redux-form";
import AnalyticsFilter from '../components/analytics/AnalyticsFilter';
import PopularServicesTable from '../components/analytics/popularServices/PopularServicesTable';
import OrdersReport from '../components/analytics/orders/OrdersReport';
import CategoryClicksTable from '../components/analytics/categoryClicks/CategoryClicksTable';
import { cleanReports, getPopularServicesReport, getOrdersReport, getCategoryClicks } from '../actions/reports';
import moment from 'moment';

let Analytics = class extends React.Component {
    constructor(props) {
        super(props);
        this.state = { currentReport: undefined, updateButtonEnabled: true };
        this._selectReport = this._selectReport.bind(this);
        this._onUpdateClick = this._onUpdateClick.bind(this);
        this._getFilterData = this._getFilterData.bind(this);
        this._setUpdateButtonEnable = this._setUpdateButtonEnable.bind(this);
    }

    _setUpdateButtonEnable(val) {
        this.setState({ updateButtonEnabled: val });
    }

    _onUpdateClick() {
        this.props.cleanReports();
        this._selectReport();
    }

    _getFilterData() {
        const { filterValues } = this.props;
        if (!filterValues)
            return null;
        const from = moment(filterValues.startDateFilter).set('hour', 0).set('minute', 0).set('second', 0);
        const to = moment(filterValues.endDateFilter).set('hour', 23).set('minute', 59).set('second', 59);
        const state = filterValues.stateFilter !== undefined ? filterValues.stateFilter.Id : undefined;
        return {
            From: moment.utc(from),
            To: moment.utc(to),
            State: state
        };
    }

    _selectReport() {
        const { filterValues } = this.props;
        const reportTypeFilter = filterValues ? filterValues.reportTypeFilter : null;
        const reportId = reportTypeFilter != null ? reportTypeFilter.Id != null ? reportTypeFilter.Id : reportTypeFilter : null;

        switch (reportId) {
            case 0:
                this.props.getOrdersReport(this._getFilterData());
                this.setState({ currentReport: <OrdersReport /> });
                break;
            case 1:
                this.props.getPopularServicesReport(this._getFilterData());
                this.setState({ currentReport: <PopularServicesTable filter={reportTypeFilter} /> });
                break;
            case 2:
                this.props.getCategoryClicks(this._getFilterData());
                this.setState({ currentReport: <CategoryClicksTable />});
                break;
            default:
                return null;
        }
    }

    render() {
        const { filterValues } = this.props;
        const { updateButtonEnabled } = this.state;
        return (
            <div style={{ marginTop: '-15px', marginLeft: '15px', paddingRight: '15px' }}>
                <AnalyticsFilter setUpdateButtonEnable={this._setUpdateButtonEnable} />
                <div className='container-fluid'>
                    <Button bsStyle='success' onClick={this._onUpdateClick} disabled={!updateButtonEnabled}>Обновить</Button>
                </div>
                <div className='container-fluid'>
                    {this.state.currentReport}
                </div>
            </div>);
    }
}

function mapToProps(state, props) {
    const filterValues = getFormValues('AnalyticsFilter')(state);
    return {
        filterValues
    }
}

Analytics = reduxForm({
    form: 'Analytics',
})(Analytics);

Analytics = connect(mapToProps, { getFormValues, cleanReports, getPopularServicesReport, getOrdersReport, getCategoryClicks })(Analytics);

export default Analytics;


// WEBPACK FOOTER //
// ./src/containers/Analytics.jsx